import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoMessageTypeEnum } from '@websky/graphql';
import { ThemeProvider, useTheme } from '../../../theme';
import Notification from '../../../Notification';
const ServiceSummaryNotification = ({ status }) => {
    const { t } = useTranslation('Cart');
    const { ServiceSummaryNotification: theme } = useTheme('ServiceSummary');
    const isUnconfirmed = status === 'unconfirmed';
    const messageStatus = isUnconfirmed ? InfoMessageTypeEnum.Warning : InfoMessageTypeEnum.Info;
    const message = t(isUnconfirmed
        ? 'The service you have added cannot be activated. Try connecting later or contact the airline operator.'
        : 'The service is awaiting confirmation. Do not close or refresh the window.');
    return (React.createElement(ThemeProvider, { value: {
            Notification: {
                Notification: {
                    wrapper: theme.wrapper,
                    context: theme.context,
                    warning: theme.warning,
                    info: theme.info,
                    text: theme.text
                }
            }
        } },
        React.createElement(Notification, { type: "context", status: messageStatus, infoMessage: {
                text: message,
                type: messageStatus,
                code: `${status}-services`
            }, hideIcon: true })));
};
export default ServiceSummaryNotification;
